import { StripeElementLocale } from '@stripe/stripe-js'
import { Conversion } from 'types/sizeConversion'

export const defaultSizeConversion = (
  locale: StripeElementLocale
): Conversion => {
  const conversion = localStorage.getItem('selectedConversion')

  if (conversion) {
    return conversion as Conversion
  }

  return conversionForLocale(locale)
}

export const conversionForLocale = (
  locale: StripeElementLocale
): Conversion => {
  if (locale === 'en') {
    return 'uk'
  }

  return 'eu'
}

export const storeConversionInLocalStorage = (conversion: Conversion): void => {
  localStorage.setItem('selectedConversion', conversion)
}
